import { Link } from 'gatsby';
import { Box } from '@mui/material';
import React from 'react';

interface InlineImageProps {
  value?: {
    inlineImage: {
      image: {
        asset: {
          url: string;
        };
      };
      width: string[];
      mt: string[];
      mr: string[];
      link?: string;  // Optional link property
      linkType?: 'path' | 'url';  // Optional linkType property
      newTab: boolean;
    };
  };
}

const InlineImage = ({ value }: InlineImageProps) => {
  const image = value?.inlineImage;
  const imageUrl = image?.image?.asset?.url ?? 'https://via.placeholder.com/150';
  const link = image?.link;
  const linkType = image?.linkType;

  // Create the image component
  const imageComponent = (
    <Box
      className="inline-image"
      component="img"
      width={image?.width ?? '100%'}
      height="auto"
      mt={image?.mt ?? '-4px'}
      mr={image?.mr ?? '0'}
      src={imageUrl}
      alt="inlineImage"
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
      }}
    />
  );

  if (link) {
    if (linkType === 'path') {
      // Use Gatsby Link for internal navigation
      return (
        <Link to={link} style={{ display: 'inline-block', verticalAlign: 'middle' }}>
          {imageComponent}
        </Link>
      );
    } else if (linkType === 'url') {
      // Use standard anchor tag for external URLs
      return (
        <a href={link} target={image?.newTab ? "_blank" : "_self"} rel={image?.newTab ? "noopener noreferrer" : undefined} style={{ display: 'inline-block', verticalAlign: 'middle' }}>
          {imageComponent}
        </a>
      );
    }
  }

  return imageComponent;
};

export default InlineImage;
